var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"sell-sheets-block",class:[
    { 'sell-sheets-block--is-active': _vm.item.IsActive },
    { 'sell-sheets-block--is-extention': _vm.item.IsExtention } ]},[_c('p',[_c('a',{attrs:{"href":_vm.item.Url}},[_vm._v(_vm._s(_vm.item.Title))])])])}
var staticRenderFns = []

export { render, staticRenderFns }